import React from "react";
import { motion } from "framer-motion";
import { learningJourney } from "../../data/learningPath.js"; // Adjust the import path

export default function LearningJourney() {
  // Animation variants for cards
  const cardVariants = {
    hidden: { opacity: 0, x: -50 }, // Start hidden and offset to the left
    visible: {
      opacity: 1,
      x: 0, // Move into view
      transition: { duration: 0.3 }, // Faster transition (0.3 seconds)
    },
  };

  // Stagger effect for cards
  const containerVariants = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2, // Faster stagger effect (0.2 seconds between cards)
      },
    },
  };

  return (
    <section className="bg-teal-800 py-16 relative">
      {/* Half-white background effect starting from the bottom */}
      <div className="absolute bottom-0 left-0 w-full sm:h-1/3 bg-white"></div>

      <div className="relative max-w-screen-2xl mx-auto px-4 sm:mt-2">
        {/* Title Section */}
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 50 }} // Animation for the title
          whileInView={{ opacity: 1, y: 0 }} // Animate when in view
          viewport={{ once: true, amount: 0.2 }} // Trigger animation when 20% of the section is visible
          transition={{ duration: 0.3 }} // Faster title animation (0.3 seconds)
        >
          <h2 className="text-3xl font-bold text-white">
            Start your Learning Journey Today!
          </h2>
          <p className="text-lg text-white mt-2">Let's Get Started!</p>
        </motion.div>

        {/* Cards Section */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10"
          variants={containerVariants} // Apply staggered animation to the container
          initial="hidden" // Start hidden
          whileInView="visible" // Animate when in view
          viewport={{ once: true, amount: 0.2 }} // Trigger animation once when 20% of the section is visible
        >
          {learningJourney.map((elm, i) => (
            <motion.div
              key={i}
              className="bg-white shadow-lg mt-4 rounded-lg p-8 text-center transform transition-transform duration-300 hover:scale-105 min-h-[300px]"
              variants={cardVariants} // Apply card animation variants
            >
              {/* Image */}
              <div className="flex justify-center mb-10 mt-8">
                <img src={elm.imageSrc} alt={elm.title} className="h-16 w-16" />
              </div>

              {/* Title */}
              <h3 className="text-lg font-medium text-gray-800">{elm.title}</h3>

              {/* Text */}
              <p className="text-sm text-gray-600 mt-4">{elm.text}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
